export default "__VITE_ASSET__Ca3o5mv9__"